import Axios from "axios";

import { apiUrl, serializeObjToGetStr } from "../../constants";
import { fileDownloader } from "../file-downloader.service";

const downloadBaseUrl = `${apiUrl}/download`;
const config = {
    headers: { "Content-Type": "application/json-patch+json" }
};

export const importExportApi = {

  downloadEmptyExcel: (request, fileName) => {
    const query = serializeObjToGetStr(request);
    fileDownloader.download(`${downloadBaseUrl}/download-empty-excel`, fileName);
  },

  import: filePath => {
    const formData = new FormData();
    formData.append("file", filePath);
    const headers = { "Content-Type": "multipart/form-data" };

    return Axios.post(`${downloadBaseUrl}/import`, formData, {headers});
  },

  downloadInventoryExport: (request, fileName) => {
    const query = serializeObjToGetStr(request);
    return fileDownloader.download(`${downloadBaseUrl}/inventory/?${query}`, fileName);
  },
};
